import React, { useState, useMemo } from "react"; // MODIFIED: Added useMemo
import "../../../App.css";
// import "../Transactions.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

// Import tab components
import LeaveRequestTab from "../../components/modules/LeaveRequest/LeaveRequestTab";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import LeaveRecallModule from "../../components/modules/LeaveRecall/LeaveRecallModule";
import LeaveRecallTab from "../../components/modules/LeaveRecall/LeaveRecallTab";

function Leave({ user, userAccess, isHideSideMenu }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };

  // Configuration-driven tab definitions
  const tabConfigs = useMemo(() => [
    {
      id: 'leaveRequest',
      label: 'LEAVE REQUEST',
      condition: true, // Always show
      component: <LeaveRequestTab user={user} userAccess={userAccess} showGeneralMessage={showGeneralMessage} />
    },
    {
      id: 'leaveRecall',
      label: 'LEAVE RECALL',
      condition: true, // Always show
      component: <LeaveRecallTab user={user} userAccess={userAccess} showGeneralMessage={showGeneralMessage} />
    },
  ], [user, userAccess, showGeneralMessage]);

  // MODIFIED: Filter tabs based on feature flags
  const activeTabs = tabConfigs.filter(tab => tab.condition);

  // Helper for dynamic styling
  const tabStyle = (index) => `px-4 py-2 cursor-pointer font-medium transition-colors outline-none select-none ${selectedTab === index
    ? "bg-[#668fca] text-white rounded-t-lg"
    : "text-[#668fca] hover:text-[#4a6ea5]"
    }`;

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo shadow-xl">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions > "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Leave"}
                </span>
              </div>
              <h3>Leave Request & Recall</h3>
            </div>

            <div className="mainData p-5">
              <Tabs
                selectedIndex={selectedTab}
                onSelect={index => handleSelectChange(index)}
                className="react-tabs"
              >
                {/* MODIFIED: Dynamically render Tab Headers */}
                <TabList
                  className="flex flex-row items-center justify-start overflow-x-auto overflow-y-hidden text-sm border-b border-gray-200 mb-4 list-none p-0"
                  style={{ borderBottom: '1px solid #dadce0' }}
                >
                  {activeTabs.map((tab, index) => (
                    <Tab key={tab.id} className={tabStyle(index)}>
                      {tab.label}
                    </Tab>
                  ))}
                </TabList>

                <div className="requestApprovalTab">
                  {/* MODIFIED: Dynamically render Tab Content Panels */}
                  {activeTabs.map((tab) => (
                    <TabPanel key={tab.id}>
                      {tab.component}
                    </TabPanel>
                  ))}
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />
    </div>
  );
}

export default Leave;